import type { ComponentProps } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type ExecutionInProgressButtonProps = Pick<
  ComponentProps<typeof Button>,
  'className' | 'size'
>;

/** Displays the shared non-interactive action while a signable is executing. */
export function ExecutionInProgressButton({
  className,
  size = 'default',
}: ExecutionInProgressButtonProps) {
  return (
    <Button
      aria-busy="true"
      className={cn('cursor-not-allowed', className)}
      disabled
      size={size}
    >
      <Loader2 aria-hidden="true" className="animate-spin" />
      Executing...
    </Button>
  );
}
